import { AlignmentType, BorderStyle, Paragraph, ShadingType, Table, TableCell, TableLayout, TableLayoutType, TableRow, TextRun, VerticalAlign, WidthType } from "docx";


export function scope(certInApplicationUrl, certInAppDescription, criticality) {
    return new Table({
        width: { size: 105, type: WidthType.PERCENTAGE },
        alignment: AlignmentType.CENTER,
        layout: TableLayoutType.FIXED,
        spacing: { before: 600 },
        borders: {
            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        },
        rows: [


            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 5, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "Sl No.",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: true
                                    })
                                ]
                            })],

                        shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 17, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "Asset Description",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: true
                                    })
                                ]
                            })],

                        shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 11, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "Criticality of Asset",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: true
                                    })
                                ]
                            })],

                        shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 10, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "Internal IP Address",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: true
                                    })
                                ]
                            })],

                        shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 14, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "URL",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: true
                                    })
                                ]
                            })],

                        shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 8, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "Public IP Address",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: true
                                    })
                                ]
                            })],

                        shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 10, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "Location",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: true
                                    })
                                ]
                            })],
                        shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 8, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "Hash Value (in case of applications)",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: true
                                    })
                                ]
                            })],

                        shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 8, type: WidthType.PERCENTAGE },
                        indent: { left: 50, right: 50 },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 20 },
                                children: [
                                    new TextRun({
                                        text: "Version (in case of applications)",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: true
                                    })
                                ]
                            })],

                        shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 9, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                spacing: { after: 200 },
                                children: [
                                    new TextRun({
                                        text: "Other details such as make and model in case of network devices or security devices",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: true
                                    })
                                ]
                            })],

                        shading: { type: ShadingType.SOLID, color: "D5DCE4" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                ]
            }),

            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 5, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "1",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 17, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: certInAppDescription,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],

                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                    new TableCell({
                        width: { size: 11, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: criticality,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 10, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "NA",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 14, type: WidthType.PERCENTAGE },
                        children: certInApplicationUrl.split(/\s+/).map((url) =>
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: url,
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })
                        ),
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 8, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "NA",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 10, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "NA",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 8, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                children: [
                                    new TextRun({
                                        text: "NA",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 8, type: WidthType.PERCENTAGE },
                        indent: { left: 50, right: 50 },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 20 },
                                children: [
                                    new TextRun({
                                        text: "NA",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),
                    new TableCell({
                        width: { size: 9, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                alignment: AlignmentType.LEFT,
                                indent: { left: 50, right: 50 },
                                spacing: { after: 200 },
                                children: [
                                    new TextRun({
                                        text: "NA",
                                        font: "Arial",
                                        size: 22,
                                        color: "000000",
                                        italics: false,
                                        bold: false
                                    })
                                ]
                            })],
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: {
                                style: BorderStyle.SINGLE, size: 1, color: "000000",
                            },
                        }
                    }),

                ]
            }),

        ]
    })
}


export const teamNetwork = new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    layout: TableLayoutType.FIXED,
    spacing: { before: 600 },
    borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
    },
    rows: [
        new TableRow({
            children: [
                new TableCell({
                    width: { size: 7, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50 },
                            spacing: { before: 80 },
                            children: [
                                new TextRun({
                                    text: "Sl No.",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],

                    shading: { type: ShadingType.SOLID, color: "D9E2F3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    width: { size: 14, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50 },
                            spacing: { before: 80 },
                            children: [
                                new TextRun({
                                    text: "Name",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],

                    shading: { type: ShadingType.SOLID, color: "D9E2F3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    width: { size: 15, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Designation",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],

                    shading: { type: ShadingType.SOLID, color: "D9E2F3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    width: { size: 30, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Email Id",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],

                    shading: { type: ShadingType.SOLID, color: "D9E2F3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    width: { size: 16, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50 },
                            spacing: { before: 80 },
                            children: [
                                new TextRun({
                                    text: "Professional Qualifications/ Certifications ",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],

                    shading: { type: ShadingType.SOLID, color: "D9E2F3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    width: { size: 18, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80, after: 100 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Whether the resource has been listed in the Snapshot information published on CERT-In’s website (Yes/No) ",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: true
                                })
                            ]
                        })],

                    shading: { type: ShadingType.SOLID, color: "D9E2F3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "1",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            indent: { left: 50, right: 50 },
                            spacing: { before: 80, after: 80 },
                            children: [
                                new TextRun({
                                    text: "Manjunath Bhatt",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],

                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),

                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80, after: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Security Analyst",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "   ",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    children: [
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 80 },
                            indent: { left: 50, right: 50 },
                            children: [
                                new TextRun({
                                    text: "Yes",
                                    font: "Arial",
                                    size: 22,
                                    color: "000000",
                                    italics: false,
                                    bold: false
                                })
                            ]
                        })],
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000", },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                        right: {
                            style: BorderStyle.SINGLE, size: 1, color: "000000",
                        },
                    }
                }),
            ]
        }),
    ]
})
